import { useTheme } from "styled-components";

export const ArrowRight = () =>{
    const theme = useTheme();
    return <svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 10H2L7 5L2 0H0L5 5L0 10Z" fill={theme.colors.textPrimary} fillOpacity="1"/>
    </svg>
}